import { SuggestionOptions } from "@tiptap/suggestion";

export interface SuggestionItem {
  id: string;
  isNew?: boolean;
}

interface ItemsFnOptions {
  allowCreate?: boolean;
}

const VALID_SLOT_NAME = /^\w+$/;

export const itemsFn =
  (
    getItems: () => string[],
    options?: ItemsFnOptions,
  ): SuggestionOptions<SuggestionItem>["items"] =>
  ({ query }) => {
    const items = getItems();
    const candidate = query.trim();
    const lowerQuery = candidate.toLowerCase();

    const filtered: SuggestionItem[] = items
      .filter((item) => item.toLowerCase().startsWith(lowerQuery))
      .map((id) => ({ id }));

    if (
      options?.allowCreate &&
      candidate.length > 0 &&
      VALID_SLOT_NAME.test(candidate)
    ) {
      const exactMatch = items.some(
        (item) => item.toLowerCase() === lowerQuery,
      );

      if (!exactMatch) {
        filtered.push({ id: candidate, isNew: true });
      }
    }

    return filtered;
  };
